import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid';
import { cn, withErrorBoundary } from '@navi-app/utils';
import { Button } from 'baseui/button';
import { LabelMedium, ParagraphXSmall } from 'baseui/typography';
import { TFunction } from 'i18next';

type TVideoSection = {
  id: string;
  url: string | undefined;
  embedUrl: string | undefined;
  thumbnail: string;
  card: {
    title: string;
    description: string;
  };
  video: {
    title: string;
    description: string;
  };
  t: TFunction;
  isPhoneSize?: boolean;
};

const VideoSection = ({
  url,
  embedUrl,
  video,
  t,
  isPhoneSize,
}: TVideoSection) => {
  return (
    <>
      <iframe
        title="tutorial-video"
        src={embedUrl || ''}
        style={{
          width: '100%',
          minHeight: isPhoneSize ? '228px' : '350px',
          maxHeight: '425px',
        }}
        allowFullScreen
      />
      <div className="mt-6">
        <LabelMedium>{video.title}</LabelMedium>
        <ParagraphXSmall color="#5E5E5E" className="mt-1">
          {video.description}
        </ParagraphXSmall>
      </div>
      <Button
        onClick={() => window.open(url || '', '_blank')}
        className={cn(
          isPhoneSize ? '!w-full' : '',
          '!flex !place-items-center !gap-2 !mt-3 !mb-6'
        )}
      >
        {t('open_youtube')}
        <ArrowTopRightOnSquareIcon width={12} height={12} />
      </Button>
    </>
  );
};

export default withErrorBoundary(VideoSection);
